import { render, staticRenderFns } from "./PatientIndicateEdit.vue?vue&type=template&id=dfae6484&scoped=true&"
import script from "./PatientIndicateEdit.vue?vue&type=script&lang=ts&"
export * from "./PatientIndicateEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PatientIndicateEdit.vue?vue&type=style&index=0&id=dfae6484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfae6484",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VRow,VSimpleCheckbox,VSpacer})
